export default "__VITE_ASSET__c9f93efb__"